import { render, staticRenderFns } from "./SetEventOutcomeAndNote.vue?vue&type=template&id=f80c2f06&scoped=true"
import script from "./SetEventOutcomeAndNote.vue?vue&type=script&lang=ts"
export * from "./SetEventOutcomeAndNote.vue?vue&type=script&lang=ts"
import style0 from "./SetEventOutcomeAndNote.vue?vue&type=style&index=0&id=f80c2f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c2f06",
  null
  
)

export default component.exports